import { Button, Tooltip } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PlaceLink } from 'utils/link';
import { AddIcon, WarningIcon } from 'components/uiIcons';
import { ButtonSpan } from 'components/styles_components/span';
import Create from 'components/place/modal/create';
import theme from 'theme';

const CreateButton = ({
  overPlacesLimit,
  adminRole = true,
  size = 'medium',
  label = <FormattedMessage id="button.add" />,
}) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();
  const intl = useIntl();
  const navigate = useNavigate();

  const button = (
    <Button
      disabled={overPlacesLimit || !adminRole}
      size={size}
      startIcon={overPlacesLimit || !adminRole ? <WarningIcon sx={{ color: theme.palette.error.main }} /> : null}
      endIcon={<AddIcon />}
      onClick={() =>
        addModal(
          <Create
            handleClose={() => removeModal()}
            onSuccess={(place) => {
              removeModal();
              setInfo('info.place.created');
              navigate(PlaceLink(place.id));
            }}
          />
        )
      }
      variant="contained"
    >
      <ButtonSpan>{label}</ButtonSpan>
    </Button>
  );

  if (!adminRole) {
    return (
      <Tooltip title={intl.formatMessage({ id: 'user.place.no_admin' })}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  if (overPlacesLimit) {
    return (
      <Tooltip title={intl.formatMessage({ id: 'user.plan.over_places_limit' })}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

export default CreateButton;
